import { css } from "lit";

export const newCreateLinkModalStyles = css`
  .modal-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    overflow: auto;
  }

  .form-layout {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .caption {
  }

  .premium-section {
    margin-top: var(--spacing-4, 1rem);
    padding-top: var(--spacing-4, 1rem);
    border-top: 1px solid var(--sds-color-border-default-default, #e0e0e0);
  }
`;
